import styles from "./PhotographersGrid.module.css"
import { getAllPhotographers } from "../../../app/lib/prisma-db.js"

export default async function PhotographersGrid(){
    const photographers = await getAllPhotographers;
    console.log(photographers);
}